import {Popup as LeafletPopup, PopupEvent} from 'leaflet';
import {useEffect} from 'react';
import {useMap} from 'react-leaflet';

const PopupFocusHandler = () => {
  const map = useMap();

  useEffect(() => {
    const detachers = new Map<LeafletPopup, () => void>();

    const onPopupOpen = (event: PopupEvent) => {
      const popup = event.popup;
      const container = popup.getElement();
      if (!container) {
        return;
      }

      const onMouseDown = () => {
        popup.bringToFront();
      };

      container.addEventListener('mousedown', onMouseDown, true);
      detachers.set(popup, () => {
        container.removeEventListener('mousedown', onMouseDown, true);
      });
    };

    const onPopupClose = (event: PopupEvent) => {
      detachers.get(event.popup)?.();
      detachers.delete(event.popup);
    };

    map.on('popupopen', onPopupOpen);
    map.on('popupclose', onPopupClose);

    return () => {
      map.off('popupopen', onPopupOpen);
      map.off('popupclose', onPopupClose);
      detachers.forEach((detach) => {
        detach();
      });
      detachers.clear();
    };
  }, [map]);

  return null;
};

export default PopupFocusHandler;
